<div class="kexp-steering-wheel text-center min-h-24 max-w-200 ml-auto mr-auto" [ngClass]="wrapperClasses()">
  @if (loadingPaths()) {
    <div class="mt-6 text-xl">
      Loading...
    </div>
  } @else {
    <div>
      <div class="direction straight-ahead rounded-xl border-1 border-default-700 min-h-26 max-w-120 p-2 mx-4 sm:mx-auto "
           [ngClass]="straightPathClasses()">
        @let sp = straightPath();
        @if (sp) {
          <steering-wheel-button [item]="sp" (playPath)="takePath($event)"
                                 [buttonTitle]="straightTitle()"></steering-wheel-button>
        } @else {
          <div class="text-sm text-center font-semibold">Up Next</div>
          <div class="text-center mt-4">
            Nothing scheduled, you should select something!
          </div>
        }
      </div>

      <div class="mt-2 mb-1">
        <button (click)="shufflePathsEvent()" title="Change Directions" aria-label="Change Directions"
                class="shuffle-button my-2 py-1 px-3 border-2 rounded-full border-default-700">
          <svg width="24" height="24" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="inline mr-1"
               fill="currentColor">
            <path
              d="M12 4.5L10.9424 5.56543L9.75 4.37207V9.75L9.80469 9.92773C10.4069 11.7258 12.1021 12.3415 13.6279 12L12.4424 10.8076L13.5 9.75L16.5 12.75L13.5 15.75L12.4424 14.6924L13.6279 13.5C12.4955 13.7475 10.83 13.4403 9.75 12.4805L9 11.625L8.25 12.4805C7.16999 13.4403 5.50449 13.7475 4.37207 13.5L5.55762 14.6924L4.5 15.75L1.5 12.75L4.5 9.75L5.55762 10.8076L4.37207 12C5.94707 12.3525 7.7025 11.685 8.25 9.75V4.37207L7.05762 5.55762L6 4.5L9 1.5L12 4.5Z"/>
          </svg>
          {{ steeringButtonTitle() }}
        </button>
      </div>

      @let lp = leftPath();
      @let rp = rightPath();
      @if (lp || rp) {
        <div class="flex w-full justify-between gap-2 sm:gap-4">
          <div class="direction left-turn text-center w-1/2 border-1 border-default-700 p-2 rounded-xl min-h-26 ">
            @if (lp) {
              <steering-wheel-button [item]="lp" (playPath)="takePath($event)"
                                     [buttonTitle]="leftTitle()"></steering-wheel-button>
            }
          </div>
          <div class="direction right-turn text-center w-1/2 border-1 border-default-700 p-2 rounded-xl min-h-26">
            @if (rp) {
              <steering-wheel-button [item]="rp" (playPath)="takePath($event)"
                                     [buttonTitle]="rightTitle()"></steering-wheel-button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
